

function dealerCashLifting() {

    let profileService = [
        {
            name: "Cash Lifting",
            icon: "Cash Lifting",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerCashLifting",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerCashLifting",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const cashLifting = () => {
        const profileArr = [
            {
                path: "/index/cashLifting",
                name: "Cash Lifting",
                icon: "fee-master",
                logoName: "cash_Lifting",
                flag:"CASH LIFTING"
            },
        ];
        return profileArr;
    };


    let a = dashboard();
    let b = cashLifting();

    profileService[0].items = [...a, ...b];

    return profileService;
}

export default dealerCashLifting;
